<template>
  <div class="view-tasklists">
    <user-menu />
    <div class="wrapper">
      <admin-sidebar-menu v-if="admin" />
        <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">Assessment: {{ assessment_title }}</h3>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>
          <div v-show="loading" class="loading_show">
            <div class="spinner-border text-danger"></div>
          </div>
          <div class="preview-section text-align-center" v-if="loading == false && sectionIds.length == 0" style="background:none">
            No Sections to display
          </div>
          <div class="preview-section text-align-center" v-else-if="loading == false && questions.length == 0" style="background:none">
            No Questions to display
          </div>
          <div class="preview-section" v-if="loading == false && questions.length > 0">
            <div class="question-display counter_group-list">
              <div v-for="(question, index) in questions" :key="index">
                <div class="question-text">
                  <span class="counter_group-list__counter"></span>
                  {{ question.text }}
                </div>
                <div class="question-option">
                  <div class="float-left override-padding" :class="(maxScale === 7) ? 'col-1' : 'col-2'" v-for="scaleVal in maxScale">
                    <div class="radio-button">
                      <input :value="scaleVal" type="radio" name="questions" v-model="question.value">
                    </div>
                    <div class="radio-label">
                      <label >{{ scaleVal }}</label>
                    </div>
                  </div>

                </div>
                <div style="clear: both"></div>
              </div>
            </div>
            <div class="col-12" style="padding-left: 0;" v-if="indexVal < parseInt(sectionIds.length - 1)">
              <div class="col-lg-6 padding-lr-5 float-right text-align-right" style="padding-right: 0;" >
                <button
                  v-on:click="onContinue()"
                  class="btn btn-red col-8 padding-lr-5"
                  style="height: 30px;border-radius: 10px; margin-top: 2px;font-weight: bold;">Continue</button>
              </div>
              <div class="col-lg-6 padding-lr-5 float-left text-align-left">
                <button
                  v-on:click="redirectListPage()"
                  class="btn btn-white col-6 override-padding" style="margin-top: 2px; height: 30px; border-radius: 10px; font-weight: bold;"
                  >Cancel</button>
              </div>
              <div style="clear: both; margin-bottom: 25px;"></div>

            </div>
            <div class="col-12" style="padding-left: 0;" v-if="indexVal == parseInt(sectionIds.length - 1)">
              <div class="col-lg-12 padding-lr-5  text-align-center" style="padding-right: 0;">
                <button
                  v-on:click="redirectListPage()"
                  class="btn btn-red col-4 padding-lr-5"
                  style="height: 30px;border-radius: 10px; margin-top: 2px;font-weight: bold;">Close Preview</button>
              </div>
              <div style="clear: both; margin-bottom: 25px;"></div>

            </div>

          </div>

        </div>
        </div>
    </div>

  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';

export default {
        data() {
          return {
            assessmentId: '',
            assessmentAttemptId: '',
            masterAdmin: false,
            indexVal: 0,
            sectionIds: [],
            question_obj: {
              questions: [],
              section: [],
            },
            loading: false,
          }
        },

        components: {
          UserMenu,
          GoBack,
          MasteradminSidebarMenu,
          AdminSidebarMenu,
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
            getAnswersSelected: function(qindex, index, event) {
              if(event.value == true) {
                var selected_val = this.question_obj.questions[qindex].section_scale[index].value;
                for(var i=0; i<this.question_obj.questions[qindex].section_scale.length; i++) {
                  this.question_obj.questions[qindex].section_scale[i].checked = false;
                }
                if(this.question_obj.questions[qindex].update == true) {
                  this.question_obj.questions[qindex].modified = true;
                }
                this.question_obj.questions[qindex].section_scale[index].checked = true;
                this.question_obj.questions[qindex].error = 0;
                this.question_obj.questions[qindex].value = selected_val;
              }
            },
            doValidate() {
              var flag = 0;
              for(var i=0; i<this.question_obj.questions.length; i++) {
                if(this.question_obj.questions[i].value == '') {
                  this.question_obj.questions[i].error = 1;
                  flag = 1;
                }    
              }
              return flag;
            },
            onSubmit: function(status) {
              var flag = this.doValidate();
              if(flag == 0) {
                var sectionId = this.sectionIds[this.indexVal];
                axios('/assessment-section-questions-answers/' + sectionId + '/' + this.assessmentAttemptId,
                {
                  method: 'POST',
                  data: {
                    question_obj: this.question_obj,
                    status: status,
                  },
                })
                .then(() => {
                  if(status == 'Completed') {
                    this.$showModal(assessmentQuestionAnswerSuccess, { props: { assessmentAttemptId: this.assessmentAttemptId}});
                  }
                  else {
                    this.onPrevNext('Next');
                  }
                })
                .catch(() => {

                });

                
              }

            },
            onPrevNext(val) {
              if(val == 'Previous') {
                this.indexVal -= 1;
              }
              else if(val == 'Next') {
                this.indexVal += 1;
              }
              this.getSectionQuestionsLists();
            },
            getSectionLists: function() {
              this.loading = true;
              axios.get('/assessment-section-lists-preview/' + this.assessmentId)
                .then((resp) => {

                    this.sectionIds = resp.data;
                    if(this.sectionIds.length > 0) {
                      this.getSectionQuestionsLists();
                    }
                    else {
                      this.loading = false;
                    }
                    
                })
                .catch(error => {

                });
            },
            getSectionQuestionsLists: function() {
              this.loading = true;
              var sectionId = this.sectionIds[this.indexVal];
              if(sectionId) {
                  axios.get('/assessment-section-questions-lists-preview/' + sectionId, {
                  params: {
                    attempt_id: this.assessmentAttemptId,
                  }
                  })
                  .then((resp) => {
                      this.loading = false;
                      this.question_obj.questions = resp.data.questions;
                      this.question_obj.section = resp.data.section;
                  })
                  .catch(error => {

                  });

              }

            },

        },
        created() {
          this.assessmentId = this.$route.params.assessmentId;
          this.assessmentAttemptId = this.$route.params.assessmentAttemptId;
          var roles = store.state.roles;
          if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            this.masterAdmin = true;
          }
          this.admin = false;
          if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
            this.admin = true;
          }
          this.getSectionLists();
        },

}

</script>

<style scoped>

.preview-section {
  width: 50%;
  margin: 0 auto;
  background-color: #FFF;
  border-radius: 10px;
  padding: 15px 25px
}
.counter_group-list {
  counter-reset: my-sec-counter2;
}
.counter_group-list__counter:after {
  counter-increment: my-sec-counter2;
  content: counter(my-sec-counter2) ". ";
}
.question-text {
  font-size: 13px;
  padding-bottom: 10px;
  color: #555;
}
.question-display {
  margin-top: 5px;
  margin-bottom: 15px;
}
.question-option {
  padding-left: 30px;
  padding-top: 5px;
  padding-bottom: 5px;
  float: left;
  width: 100%;
}
.radio-label {
  padding-left: 3px;
  margin-top: -2px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/preview_assessment.vue